import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    // Update document direction when language changes
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language, isRTL]);

  return (
    <div className="min-h-screen bg-black logo-pattern-bg" dir={isRTL ? 'rtl' : 'ltr'}>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
